export enum AlertType {
  success,
  error,
}
